import dayjs from 'dayjs';
import { useState, useEffect } from 'react';
import axios from 'axios';
import { toast } from 'sonner';
import {
  PoliceCar,
  CreditCard,
  Gear,
  ArrowsLeftRight,
  Pen,
} from '@phosphor-icons/react';
import {
  Table,
  Input,
  Select,
  Tooltip,
  Card,
  Typography,
  Spin,
  Empty,
  Space,
  Col,
  Row,
  Skeleton,
  Switch,
} from 'antd';
import { SearchOutlined } from '@ant-design/icons';
import { CircleCheck } from 'lucide-react';
import { MaintenanceDialog } from './MaintenanceDialog';
import { SelectManagerFilter } from '../../components/FrotaFormularioComponents/SelectManagerFilter';
import { SelectDriverFilter } from '../../components/FrotaFormularioComponents/SelectDriverFilter';
import { SaveDialog } from './SaveDialog';
import { ConfigProvider } from 'antd';
import ptBR from 'antd/locale/pt_BR';
import { Modal } from 'antd';
import { Form } from 'antd';
import { DatePicker } from 'antd';

const { Title } = Typography;
const { Option } = Select;

export function TableFleet() {
  const [form] = Form.useForm();

  const [vehicles, setVehicles] = useState([]);
  const [loading, setLoading] = useState(true);
  const [searchTerm, setSearchTerm] = useState('');
  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 10,
    total: 0,
    showSizeChanger: true,
    showQuickJumper: true,
    showTotal: (total, range) => `${range[0]}-${range[1]} de ${total} itens`,
    pageSizeOptions: ['5', '10', '25', '50', '100'],
  });

  // console.log('veiculo', vehicles);

  const [maintenanceDialogOpen, setMaintenanceDialogOpen] = useState(false);
  const [selectedVehicle, setSelectedVehicle] = useState(null);
  const [changeDriver, setChangeDriver] = useState(false);
  const [employee, setEmployee] = useState(0);
  const [saveDialogOpen, setSaveDialogOpen] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);

  const [selectedRowData, setSelectedRowData] = useState(null);
  const [estados, setEstados] = useState([]);
  const [tipoVeiculo, setTipoVeiculo] = useState([]);
  const [fabricante, setFabricante] = useState([]);
  const [modelo, setModelo] = useState([]);
  const [fabricanteCodigo, setFabricanteCodigo] = useState(null);
  const [combustivel, setCombustivel] = useState([]);
  const [modeloLoading, setModeloLoading] = useState(false);
  const [centroCusto, setCentroCusto] = useState([]);
  const [tiposContrato, setTiposContrato] = useState([]);
  const [gestores, setGestores] = useState([]);
  const [grupoRestricao, setGrupoRestricao] = useState([]);
  const [empresas, setEmpresas] = useState([]);
  const [rastreadores, setRastreadores] = useState([]);
  const [tags, setTags] = useState([]);

  const [locadoras, setLocadoras] = useState([]);

  // Novo estado para controlar o loading do modal
  const [isLoadingModalData, setIsLoadingModalData] = useState(false);
  const [loadingStates, setLoadingStates] = useState({
    estados: false,
    tipoVeiculo: false,
    fabricante: false,
    // combustivel: false,
    centroCusto: false,
    tiposContrato: false,
    gestores: false,
    grupoRestricao: false,
    empresas: false,
    rastreadores: false,
    tags: false,
    locadoras: false,
  });

  // Função para atualizar o estado de loading específico
  const updateLoadingState = (key, value) => {
    setLoadingStates((prev) => {
      const newState = { ...prev, [key]: value };
      // Verifica se ainda há algum loading ativo
      const hasAnyLoading = Object.values(newState).some((loading) => loading);
      setIsLoadingModalData(hasAnyLoading);
      return newState;
    });
  };

  const fetchLocadoras = async () => {
    if (locadoras.length > 0) return; // Já carregado

    updateLoadingState('locadoras', true);
    try {
      const response = await axios.get(
        'https://radar.tlpservicos.com.br/api/veiculos/es/locadoras'
      );
      setLocadoras(response.data);
    } catch (error) {
      console.error('Erro ao buscar locadoras:', error);
      toast.error('Erro ao carregar locadoras');
    } finally {
      updateLoadingState('locadoras', false);
    }
  };

  const fetchEstados = async () => {
    if (estados.length > 0) return; // Já carregado

    updateLoadingState('estados', true);
    try {
      const response = await axios.get(
        'https://radar.tlpservicos.com.br/api/veiculos/es/estado'
      );
      setEstados(response.data);
    } catch (error) {
      console.error('Erro ao buscar estados:', error);
      toast.error('Erro ao carregar estados');
    } finally {
      updateLoadingState('estados', false);
    }
  };

  const fetchTiposVeiculos = async () => {
    updateLoadingState('tipoVeiculo', true);
    try {
      const response = await axios.get(
        'https://radar.tlpservicos.com.br/api/veiculos/es/familia-veiculos'
      );
      setTipoVeiculo(response.data);
    } catch (error) {
      console.error('Erro ao buscar tipo veiculo:', error);
      toast.error('Erro ao carregar tipo veiculo');
    } finally {
      updateLoadingState('tipoVeiculo', false);
    }
  };

  const fetchFabricante = async () => {
    updateLoadingState('fabricante', true);
    try {
      const response = await axios.get(
        'https://radar.tlpservicos.com.br/api/veiculos/es/fabricantes'
      );
      setFabricante(response.data.informacoesVeiculoVo);
    } catch (error) {
      console.error('Erro ao buscar fabricante:', error);
      toast.error('Erro ao carregar fabricante');
    } finally {
      updateLoadingState('fabricante', false);
    }
  };

  // const fetchCombustivel = async () => {
  //   updateLoadingState('combustivel', true);
  //   try {
  //     const response = await axios.get(
  //       'https://radar.tlpservicos.com.br/api/veiculos/es/combustiveis'
  //     );
  //     setCombustivel(
  //       response.data.filter((item) =>
  //         ['BDI', 'DIE', 'ETN', 'GAC', 'GLP'].includes(item.codigo)
  //       )
  //     );
  //   } catch (error) {
  //     console.error('Erro ao buscar combustivel:', error);
  //     toast.error('Erro ao carregar combustivel');
  //   } finally {
  //     updateLoadingState('combustivel', false);
  //   }
  // };

  const fetchCentroCusto = async (rowData) => {
    updateLoadingState('centroCusto', true);
    try {
      if (rowData.codigo_cliente_tl) {
        const response = await axios.get(
          `https://radar.tlpservicos.com.br/api/ticketlog/informacao-adicional/${rowData.codigo_cliente_tl}/4`
        );
        setCentroCusto(response.data.informacaoAdicional1.informacoes);
      }
    } catch (error) {
      console.error('Erro ao buscar centro custo:', error);
      toast.error('Erro ao carregar centro custo');
    } finally {
      updateLoadingState('centroCusto', false);
    }
  };

  const fetchTiposContrato = async (rowData) => {
    updateLoadingState('tiposContrato', true);
    try {
      if (rowData.codigo_cliente_tl) {
        const response = await axios.get(
          `https://radar.tlpservicos.com.br/api/ticketlog/tipo-frota/${rowData.codigo_cliente_tl}/4`
        );
        setTiposContrato(response.data.informacoes);
      }
    } catch (error) {
      console.error('Erro ao buscar tipos contrato:', error);
      toast.error('Erro ao carregar tipos contrato');
    } finally {
      updateLoadingState('tiposContrato', false);
    }
  };

  const fetchGestor = async (rowData) => {
    updateLoadingState('gestores', true);
    try {
      if (rowData.codigo_cliente_tl) {
        const response = await axios.get(
          `https://radar.tlpservicos.com.br/api/ticketlog/veiculo-responsavel/${rowData.codigo_cliente_tl}/4`
        );
        setGestores(response.data.informacoes);
      }
    } catch (error) {
      console.error('Erro ao buscar gestores:', error);
      toast.error('Erro ao carregar gestores');
    } finally {
      updateLoadingState('gestores', false);
    }
  };

  const fetchGrupoRestricao = async (rowData) => {
    updateLoadingState('grupoRestricao', true);
    try {
      if (rowData.codigo_cliente_tl) {
        const response = await axios.get(
          `https://radar.tlpservicos.com.br/api/ticketlog/grupo-restricao/${rowData.codigo_cliente_tl}/4`
        );
        setGrupoRestricao(response.data.informacoes);
      }
    } catch (error) {
      console.error('Erro ao buscar grupo restricao:', error);
      toast.error('Erro ao carregar grupo restricao');
    } finally {
      updateLoadingState('grupoRestricao', false);
    }
  };

  const fetchEmpresa = async () => {
    updateLoadingState('empresas', true);
    try {
      const response = await axios.get(
        'https://radar.tlpservicos.com.br/api/veiculos/es/empresas'
      );
      setEmpresas(response.data);
    } catch (error) {
      console.error('Erro ao buscar empresas:', error);
      toast.error('Erro ao carregar empresas');
    } finally {
      updateLoadingState('empresas', false);
    }
  };

  const fetchTags = async () => {
    updateLoadingState('tags', true);
    try {
      const response = await axios.get(
        'https://radar.tlpservicos.com.br/api/veiculos/es/tag'
      );
      setTags(response.data);
    } catch (error) {
      console.error('Erro ao buscar tags:', error);
      toast.error('Erro ao carregar tags');
    } finally {
      updateLoadingState('tags', false);
    }
  };

  const fetchRastreador = async () => {
    updateLoadingState('rastreadores', true);
    try {
      const response = await axios.get(
        'https://radar.tlpservicos.com.br/api/veiculos/es/rastreadores-empresa'
      );
      setRastreadores(response.data);
    } catch (error) {
      console.error('Erro ao buscar rastreadores:', error);
      toast.error('Erro ao carregar rastreadores');
    } finally {
      updateLoadingState('rastreadores', false);
    }
  };

  const findCodigoByDescricao = (descricao) => {
    const item = fabricante.find(
      (f) => f.descricao.toLowerCase() === descricao.toLowerCase()
    );
    return item ? item.codigo : null;
  };

  const fetchModelo = async (codigo) => {
    try {
      const response = await axios.get(
        `https://radar.tlpservicos.com.br/api/ticketlog/modelo/${codigo}`
      );
      setModelo(response.data.modelos);
    } catch (error) {
      setModelo([]);
      console.error('Erro ao buscar modelos:', error);
      toast.error('Erro ao carregar modelos');
    } finally {
      setModeloLoading(false);
    }
  };

  useEffect(() => {
    async function fetchData() {
      setModeloLoading(true);
      try {
        const response = await axios.get(
          `https://radar.tlpservicos.com.br/api/ticketlog/modelo/${fabricanteCodigo}`
        );
        setModelo(response.data.modelos);
      } catch (error) {
        console.error('Erro na requisição:', error);
        setModelo([]);
      } finally {
        setModeloLoading(false);
      }
    }
    fetchData();
  }, [fabricanteCodigo]);

  const showModal = async (rowData) => {
    setSelectedRowData(rowData);
    setIsModalOpen(true);
    setIsLoadingModalData(true); // Inicia o loading

    // Inicia todos os fetchs simultaneamente
    const promises = [
      // fetchCombustivel(),
      fetchLocadoras(),
      fetchTiposVeiculos(),
      fetchFabricante(),
      fetchCentroCusto(rowData),
      fetchTiposContrato(rowData),
      fetchGestor(rowData),
      fetchGrupoRestricao(rowData),
      fetchEmpresa(),
      fetchTags(),
      fetchRastreador(),
      fetchEstados(),
    ];

    try {
      await Promise.all(promises);
    } catch (error) {
      console.error('Erro ao carregar dados do modal:', error);
    }

    // Configura os valores do formulário após todos os dados serem carregados
    const formData = {
      ...rowData,
      inicio_contrato: rowData.inicio_contrato ? dayjs(rowData.inicio_contrato) : null,
      fim_contrato: rowData.fim_contrato ? dayjs(rowData.fim_contrato) : null,
      data_entrega: rowData.data_entrega ? dayjs(rowData.data_entrega) : null,
      data_devolucao: rowData.data_devolucao ? dayjs(rowData.data_devolucao) : null,
    };

    form.setFieldsValue(formData);
  };

  const handleOk = () => {
    form.submit();
  };

  const onFinish = async (values) => {
    const datasFormatoString = {
      ...values,
      inicio_contrato: values.inicio_contrato
        ? values.inicio_contrato.format('YYYY-MM-DD')
        : null,
      fim_contrato: values.fim_contrato
        ? values.fim_contrato.format('YYYY-MM-DD')
        : null,
      data_entrega: values.data_entrega
        ? values.data_entrega.format('YYYY-MM-DD')
        : null,
      data_devolucao: values.data_devolucao
        ? values.data_devolucao.format('YYYY-MM-DD')
        : null,
      empresa_id: isNaN(Number(values.empresa_id))
        ? empresas.find((item) => item.nome_empresa === values.empresa_id)?.id
        : values.empresa_id,
      ano_fabricacao: Number(values.ano_fabricacao),
      capacidade_tanque: Number(values.capacidade_tanque),
      rastreador_empresa_id: isNaN(Number(values.rastreador_empresa_id))
        ? rastreadores.find((item) => item.nome_empresa === values.rastreador_empresa_id)
            ?.id
        : values.rastreador_empresa_id,
      valor_contrato: Number(values.valor_contrato),
      tag_id: isNaN(Number(values.tag_id))
        ? tags.find((item) => item.nome === values.tag_id)?.id
        : values.tag_id,
    };

    const dadosCompletos = {
      ...selectedRowData,
      ...datasFormatoString,
    };

    // Filtrar apenas as chaves permitidas
    const chavesPermitidas = [
      'estado_id',
      'ano_fabricacao',
      'ano_modelo',
      'renavam',
      'chassi',
      'modelo',
      'motorizacao',
      'fabricante',
      'locadora_id',
      'data_entrega',
      'data_devolucao',
      'capacidade_tanque',
      'descricao',
      'cor',
      'tag_id',
      'inicio_contrato',
      'fim_contrato',
      'valor_contrato',
      'gestor_id',
      'condutor_id',
      'empresa_id',
      'situacao_id',
      'status',
      'rastreador_empresa_id',
      'empresa_cartao_combustivel_id',
      'conectado_cartao_combustivel',
      'valor_cartao',
      'cartao_associado',
      'usuario',
      'familia_veiculo_tl',
      'codigo_responsavel_veiculo_tl',
      'tipo_frota_tl',
      'codigo_grupo_restricao_tl',
      'codigo_cc_tl',
    ];

    const dadosParaEnvio = {};
    chavesPermitidas.forEach((chave) => {
      if (dadosCompletos.hasOwnProperty(chave)) {
        dadosParaEnvio[chave] = dadosCompletos[chave];
      }
    });

    try {
      const response = await axios.put(
        `https://radar.tlpservicos.com.br/api/veiculos/${dadosCompletos.placa}`,
        dadosParaEnvio
      );

      // Mostrar mensagem de sucesso
      toast.success('Veículo atualizado com sucesso!');

      // Fechar modal
      setIsModalOpen(false);
      setSelectedRowData(null);
      form.resetFields();

      // Atualizar a tabela
      fetchVehicles(pagination.current, pagination.pageSize);
    } catch (error) {
      console.error('Erro ao atualizar veículo:', error);
      toast.error('Erro ao atualizar veículo. Tente novamente.');
    }
  };

  const handleDriverChangeSuccess = () => {
    // Atualizar a tabela
    fetchVehicles(pagination.current, pagination.pageSize);
    // Resetar o estado de mudança de condutor
    setChangeDriver(false);
    setEmployee(0);
  };

  const handleCancel = () => {
    setIsModalOpen(false);
    setSelectedRowData(null);
    form.resetFields();
  };

  function cancelSaveDialog() {
    setSaveDialogOpen(false);
    setChangeDriver(false);
  }

  const openSaveDialog = () => {
    setSaveDialogOpen(true);
  };

  const openMaintenanceDialog = (vehicle) => {
    setSelectedVehicle(vehicle);
    setMaintenanceDialogOpen(true);
  };

  const handleMaintenanceSuccess = () => {
    fetchVehicles();
  };

  function sanitizeName(nome) {
    if (nome == '' || nome == undefined || nome == null) {
      return 'Nome Desconhecido';
    }
    return nome;
  }

  const fetchVehicles = async (page = 1, pageSize = 10) => {
    const skip = (page - 1) * pageSize;
    try {
      setLoading(true);
      const response = await axios.get(
        `https://radar.tlpservicos.com.br/api/veiculos?skip=${skip}&limit=${pageSize}`
      );
      if (response.status === 200) {
        setVehicles(response.data.items);
        setPagination((prev) => ({
          ...prev,
          total: response.data.totalCount,
          current: page,
          pageSize: pageSize,
        }));
      }
    } catch (error) {
      console.error('Erro ao buscar veículos:', error);
      toast.error('Erro ao carregar a lista de veículos');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchVehicles();
  }, []);

  // Filtrar dados - REMOVER esta lógica pois interfere na paginação
  // const filteredData = vehicles.filter((vehicle) => {
  //   if (!searchTerm) return true;
  //   return (
  //     vehicle.placa.toLowerCase().includes(searchTerm.toLowerCase()) ||
  //     sanitizeName(vehicle.tecnico_id)
  //       .toLowerCase()
  //       .includes(searchTerm.toLowerCase()) ||
  //     vehicle.descricao.toLowerCase().includes(searchTerm.toLowerCase()) ||
  //     sanitizeName(vehicle.gestor_nome)
  //       .toLowerCase()
  //       .includes(searchTerm.toLowerCase()) ||
  //     sanitizeName(vehicle.condutor_nome)
  //       .toLowerCase()
  //       .includes(searchTerm.toLowerCase())
  //   );
  // });

  // Função para buscar com filtro
  const fetchVehiclesWithSearch = async (page = 1, pageSize = 10, search = '') => {
    const skip = (page - 1) * pageSize;
    try {
      setLoading(true);
      let url = `https://radar.tlpservicos.com.br/api/veiculos?skip=${skip}&limit=${pageSize}`;

      // Se há termo de busca, adiciona à query
      if (search.trim()) {
        url += `&search=${encodeURIComponent(search.trim())}`;
      }

      const response = await axios.get(url);

      if (response.status === 200) {
        setVehicles(response.data.items);
        setPagination((prev) => ({
          ...prev,
          total: response.data.totalCount,
          current: page,
          pageSize: pageSize,
        }));
      }
    } catch (error) {
      console.error('Erro ao buscar veículos:', error);
      toast.error('Erro ao carregar a lista de veículos');
    } finally {
      setLoading(false);
    }
  };

  // Handle search
  const handleSearch = (value) => {
    setSearchTerm(value);
    fetchVehiclesWithSearch(1, pagination.pageSize, value);
  };

  const fetchAtivarDesativarVeiculo = async (dadosVeiculo) => {
    setVehicles((prevVeiculos) =>
      prevVeiculos.map((v) =>
        v.id === dadosVeiculo.id
          ? {
              ...v,
              deletado: !v.deletado,
            }
          : v
      )
    );

    const body = {
      placa: String(dadosVeiculo.placa),
      codigo_cliente: String(dadosVeiculo.codigo_cliente_tl),
    };

    const url = dadosVeiculo.deletado
      ? 'https://radar.tlpservicos.com.br/api/veiculos/ativar'
      : 'https://radar.tlpservicos.com.br/api/veiculos/desativar';

    try {
      const response = await axios.post(url, body, {
        headers: {
          accept: 'application/json',
          'Content-Type': 'application/json',
        },
      });

      return response.data;
    } catch (error) {
      console.error('Erro:', error.response?.data);
      console.error('Status:', error.response?.status);
      throw error;
    }
  };

  const columns = [
    {
      title: 'Placa',
      dataIndex: 'placa',
      key: 'placa',
      sorter: (a, b) => a.placa.localeCompare(b.placa),
      render: (text, record) => (
        <div>
          <div className="font-medium">{text}</div>
          <div className="text-xs text-gray-500">{record.descricao}</div>
        </div>
      ),
    },
    {
      title: 'Gestor',
      dataIndex: 'gestor_nome',
      key: 'gestor_nome',
      render: (text) => sanitizeName(text),
    },
    {
      title: 'Condutor',
      dataIndex: 'condutor_nome',
      key: 'condutor_nome',
      render: (text, record) => {
        if (changeDriver.id === record.id) {
          return (
            <div className="flex items-center justify-center h-full w-72">
              <SelectDriverFilter setEmployee={setEmployee} />
            </div>
          );
        }
        return sanitizeName(text);
      },
    },
    {
      title: 'Valor do Cartão',
      dataIndex: 'valor_cartao',
      key: 'valor_cartao',
      sorter: (a, b) => (a.valor_cartao || 0) - (b.valor_cartao || 0),
      render: (value) => {
        if (value !== null && value !== undefined) {
          return value.toLocaleString('pt-BR', {
            style: 'currency',
            currency: 'BRL',
          });
        }
        return 'R$ 0,00';
      },
    },
    {
      title: 'Ações',
      key: 'actions',
      width: 200,
      render: (_, record) => (
        <Space size="small">
          <Tooltip title="Enviar para manutenção">
            <PoliceCar
              size={24}
              className={`cursor-pointer transition-colors duration-200 ${
                record.situacao_id == 5
                  ? 'text-red-600 cursor-not-allowed'
                  : 'text-gray-500 hover:text-red-600'
              }`}
              onClick={() => record.situacao_id != 5 && openMaintenanceDialog(record)}
            />
          </Tooltip>

          <Tooltip title="Conectar TicketLog">
            <CreditCard
              size={24}
              className="text-yellow-500 hover:text-yellow-600 cursor-pointer transition-colors duration-200"
            />
          </Tooltip>

          <Tooltip title="Configurações">
            <Pen
              size={24}
              className="text-gray-500 hover:text-red-600 cursor-pointer transition-colors duration-200"
              onClick={() => showModal(record)}
            />
          </Tooltip>

          {changeDriver.id === record.id ? (
            <Tooltip title="Salvar mudanças">
              <CircleCheck
                size={24}
                className="text-green-400 cursor-pointer hover:text-green-500 transition-colors duration-200"
                onClick={() => openSaveDialog()}
              />
            </Tooltip>
          ) : (
            <Tooltip title="Trocar condutor">
              <ArrowsLeftRight
                size={24}
                className="text-gray-600 cursor-pointer hover:text-blue-600 transition-colors duration-200"
                onClick={() => setChangeDriver({ id: record.id, placa: record.placa })}
              />
            </Tooltip>
          )}
          <Tooltip title="Ativar/Desativar">
            <Switch
              checked={!record.deletado}
              onChange={() => fetchAtivarDesativarVeiculo(record)}
            />
          </Tooltip>
        </Space>
      ),
    },
  ];

  // CORRIGIR: Esta função agora chama fetchVehiclesWithSearch
  const handleTableChange = (paginationConfig, filters, sorter) => {
    fetchVehiclesWithSearch(
      paginationConfig.current,
      paginationConfig.pageSize,
      searchTerm
    );
  };

  useEffect(() => {
    if (tiposContrato.length > 0 && selectedRowData?.tipo_frota_tl && isModalOpen) {
      const tipoContratoItem = tiposContrato.find(
        (item) => item.codigo === selectedRowData.tipo_frota_tl
      );

      if (tipoContratoItem) {
        const displayValue = `${tipoContratoItem.descricao}`;
        form.setFieldValue('tipo_frota_tl', displayValue);
      }
    }
  }, [tiposContrato, selectedRowData, isModalOpen]);

  useEffect(() => {
    if (centroCusto.length > 0 && selectedRowData?.codigo_cc_tl && isModalOpen) {
      console.log('centroCusto', centroCusto);
      console.log('selectedRowData.codigo_cc_tl', selectedRowData.codigo_cc_tl);
      const centroCustoItem = centroCusto.find(
        (item) => item.codigo === selectedRowData.codigo_cc_tl
      );

      if (centroCustoItem) {
        const displayValue = `${centroCustoItem.descricao}`;
        form.setFieldValue('codigo_cc_tl', displayValue);
      }
    }
  }, [centroCusto, selectedRowData, isModalOpen]);

  useEffect(() => {
    if (
      grupoRestricao.length > 0 &&
      selectedRowData?.codigo_grupo_restricao_tl &&
      isModalOpen
    ) {
      const tipoGrupoRestricao = grupoRestricao.find(
        (item) => item.codigo === selectedRowData.codigo_grupo_restricao_tl
      );

      if (tipoGrupoRestricao) {
        const displayValue = `${tipoGrupoRestricao.descricao}`;
        form.setFieldValue('codigo_grupo_restricao_tl', displayValue);
      }
    }
  }, [grupoRestricao, selectedRowData, isModalOpen]);

  useEffect(() => {
    if (empresas.length > 0 && selectedRowData?.empresa_id && isModalOpen) {
      const tipoEmpresa = empresas.find(
        (item) => item.id === selectedRowData.empresa_id
      );
      if (tipoEmpresa) {
        const displayValue = `${tipoEmpresa.nome_empresa}`;
        form.setFieldValue('empresa_id', displayValue);
      }
    }
  }, [empresas, selectedRowData, isModalOpen]);

  useEffect(() => {
    if (fabricante.length > 0 && selectedRowData?.fabricante && isModalOpen) {
      console.log('selectedRowData?.fabricante', selectedRowData?.fabricante);
      console.log('fabricante', fabricante);
      const tipoFabricante = fabricante.find(
        (item) =>
          item.descricao.toLowerCase() === selectedRowData.fabricante.toLowerCase()
      );
      console.log('tipoFabricante', tipoFabricante);
      fetchModelo(tipoFabricante.codigo);
      if (tipoFabricante) {
        const displayValue = `${tipoFabricante.descricao}`;
        form.setFieldValue('fabricante', displayValue);
      }
    }
  }, [fabricante, selectedRowData, isModalOpen]);

  useEffect(() => {
    if (
      rastreadores.length > 0 &&
      selectedRowData?.rastreador_empresa_id &&
      isModalOpen
    ) {
      const tipoRastreador = rastreadores.find(
        (item) => item.id === selectedRowData.rastreador_empresa_id
      );

      if (tipoRastreador) {
        const displayValue = `${tipoRastreador.nome_empresa}`;
        form.setFieldValue('rastreador_empresa_id', displayValue);
      }
    }
  }, [rastreadores, selectedRowData, isModalOpen]);

  useEffect(() => {
    if (tags.length > 0 && selectedRowData?.tag_id && isModalOpen) {
      const tipoTags = tags.find((item) => item.id === selectedRowData.tag_id);

      if (tipoTags) {
        const displayValue = `${tipoTags.nome}`;
        form.setFieldValue('tag_id', displayValue);
      }
    }
  }, [tags, selectedRowData, isModalOpen]);

  useEffect(() => {
    if (centroCusto.length > 0 && selectedRowData?.codigo_cc_tl && isModalOpen) {
      const tipoCentroCusto = centroCusto.find(
        (item) => item.codigo === selectedRowData.codigo_cc_tl
      );

      if (tipoCentroCusto) {
        const displayValue = `${tipoCentroCusto.codigoInformacaoAdicional} - ${tipoCentroCusto.descricao}`;
        form.setFieldValue('codigo_cc_tl', displayValue);
      }
    }
  }, [centroCusto, selectedRowData, isModalOpen]);

  useEffect(() => {
    if (locadoras.length > 0 && selectedRowData?.locadora_id && isModalOpen) {
      const tipoLocadoras = locadoras.find(
        (item) => item.id === selectedRowData.locadora_id
      );
      if (tipoLocadoras) {
        const displayValue = `${tipoLocadoras.nome.toUpperCase()}`;
        form.setFieldValue('locadora_id', displayValue);
      }
    }
  }, [locadoras, selectedRowData, isModalOpen]);

  // useEffect(() => {
  //   if (combustivel.length > 0 && selectedRowData?.tipo_combustivel_tl && isModalOpen) {
  //     const tipoCombustivel = combustivel.find(
  //       (item) => item.codigo === selectedRowData.tipo_combustivel_tl
  //     );
  //     if (tipoCombustivel) {
  //       const displayValue = `${tipoCombustivel.descricao.toUpperCase()}`;
  //       form.setFieldValue('tipo_combustivel_tl', displayValue);
  //     }
  //   }
  // }, [combustivel, selectedRowData, isModalOpen]);

  const FieldSkeleton = ({ width = '100%' }) => (
    <Skeleton.Input active size="default" style={{ width }} />
  );

  const tipoFrotaWatch = Form.useWatch('tipo_frota_tl', form);
  const idTipoContratoAlugado = 175315;
  const idTipoContratoPropria = 43041;

  return (
    <div className="px-2">
      <Card style={{ backgroundColor: '#333', borderRadius: '8' }} bordered={false}>
        <div className="mb-6 ">
          <Title level={2} className="mb-6" style={{ color: '#ffffff' }}>
            Gerenciamento de Veículos
          </Title>

          <div className="mb-6 flex flex-col md:flex-row justify-between items-start md:items-center gap-4">
            <Input
              placeholder="Buscar por placa, técnico, gestor..."
              value={searchTerm}
              onChange={(e) => handleSearch(e.target.value)}
              prefix={<SearchOutlined />}
              style={{ width: 300 }}
              allowClear
            />
          </div>
          <style>{`
  .ant-pagination .ant-pagination-options-quick-jumper input {
    color: #000000 !important;
    background-color: #ffffff !important;
    border: 1px solid #d9d9d9 !important;
  }
  .ant-pagination .ant-pagination-options-quick-jumper input:hover {
    border-color: #40a9ff !important;
  }
  .ant-pagination .ant-pagination-options-quick-jumper input:focus {
    border-color: #1890ff !important;
    box-shadow: 0 0 0 2px rgba(24, 144, 255, 0.2) !important;
    color: #000000 !important;
  }
  .ant-pagination .ant-pagination-options-quick-jumper input::placeholder {
    color: #999999 !important;
  }
`}</style>
          <ConfigProvider
            locale={ptBR}
            theme={{
              components: {
                Table: {
                  headerBg: '#2d2d2d',
                  headerColor: '#ffffff',
                },
                Pagination: {
                  colorText: '#fff',
                  colorTextDisabled: '#999999',
                  itemActiveBg: 'transparent',
                  itemActiveColorDisabled: '#ffffff',
                },
              },
            }}
          >
            <Table
              columns={columns}
              dataSource={vehicles}
              loading={loading}
              pagination={pagination}
              onChange={handleTableChange}
              rowKey="id"
              locale={{
                emptyText: <Empty description="Nenhum veículo encontrado" />,
              }}
              scroll={{ x: 800 }}
              size="middle"
            />
          </ConfigProvider>
        </div>
      </Card>

      {saveDialogOpen && (
        <SaveDialog
          open={saveDialogOpen}
          onOpenChange={(open) => {
            setSaveDialogOpen(open);
            if (!open) {
              // Se está fechando o modal, resetar o estado
              setChangeDriver(false);
              setEmployee(0);
            }
          }}
          data={{ condutor_id: employee.id, placa: changeDriver.placa }}
          onSuccess={handleDriverChangeSuccess}
        />
      )}

      <MaintenanceDialog
        vehicle={selectedVehicle}
        open={maintenanceDialogOpen}
        onOpenChange={setMaintenanceDialogOpen}
        onSuccess={handleMaintenanceSuccess}
      />

      {isModalOpen && selectedRowData && (
        <Modal
          styles={{
            content: { backgroundColor: '#333' },
            body: { backgroundColor: '#333', color: '#fff' },
            header: {
              backgroundColor: '#333',
              color: '#fff',
              border: 'none',
            },
            footer: { backgroundColor: '#333' },
          }}
          title={
            <span style={{ color: '#fff', fontSize: 32 }}>{selectedRowData.placa}</span>
          }
          closable={{ 'aria-label': 'Custom Close Button' }}
          open={isModalOpen}
          onOk={handleOk}
          onCancel={handleCancel}
          okText="Salvar"
          cancelText="Cancelar"
          width={1000}
        >
          <div>
            {isLoadingModalData ? (
              // Skeleton enquanto carrega
              <div>
                <Card
                  title="Informações do Veículo"
                  style={{
                    backgroundColor: '#444',
                    border: '1px solid #444',
                    marginBottom: '-10px',
                  }}
                  styles={{
                    header: {
                      height: '40px',
                      minHeight: '40px',
                      backgroundColor: '#444',
                      color: '#fff',
                      fontSize: '20px',
                    },
                    body: {
                      paddingTop: '8px',
                      backgroundColor: '#444',
                      color: '#fff',
                    },
                  }}
                >
                  <Row gutter={16} style={{ marginBottom: 16 }}>
                    <Col flex="auto">
                      <FieldSkeleton />
                    </Col>
                    <Col span={4}>
                      <FieldSkeleton />
                    </Col>
                    <Col span={4}>
                      <FieldSkeleton />
                    </Col>
                    <Col span={4}>
                      <FieldSkeleton />
                    </Col>
                    <Col span={4}>
                      <FieldSkeleton />
                    </Col>
                  </Row>
                </Card>

                <Card
                  title="Responsáveis e Situação"
                  style={{
                    backgroundColor: '#444',
                    border: '1px solid #444',
                    marginTop: '24px',
                    marginBottom: '-10px',
                  }}
                  styles={{
                    header: {
                      height: '40px',
                      minHeight: '40px',
                      backgroundColor: '#444',
                      color: '#fff',
                      fontSize: '20px',
                    },
                    body: {
                      paddingTop: '8px',
                      backgroundColor: '#444',
                      color: '#fff',
                    },
                  }}
                >
                  <Row gutter={16} style={{ marginBottom: 16 }}>
                    <Col flex="auto">
                      <FieldSkeleton />
                    </Col>
                    <Col span={4}>
                      <FieldSkeleton />
                    </Col>
                    <Col span={4}>
                      <FieldSkeleton />
                    </Col>
                    <Col span={4}>
                      <FieldSkeleton />
                    </Col>
                    <Col span={4}>
                      <FieldSkeleton />
                    </Col>
                  </Row>
                </Card>

                <Card
                  title="Rastreador e Tags"
                  style={{
                    backgroundColor: '#444',
                    border: '1px solid #444',
                    marginTop: '24px',
                    marginBottom: '12px',
                  }}
                  styles={{
                    header: {
                      height: '40px',
                      minHeight: '40px',
                      backgroundColor: '#444',
                      color: '#fff',
                      fontSize: '20px',
                    },
                    body: {
                      paddingTop: '8px',
                      backgroundColor: '#444',
                      color: '#fff',
                    },
                  }}
                >
                  <Row gutter={16} style={{ marginBottom: 16 }}>
                    <Col span={6}>
                      <FieldSkeleton />
                    </Col>
                    <Col span={6}>
                      <FieldSkeleton />
                    </Col>
                  </Row>
                </Card>
              </div>
            ) : (
              // Formulário completo quando dados carregados
              <Form form={form} layout="vertical" onFinish={onFinish}>
                {/* Informações do Veículo */}
                <Card
                  title="Informações do Veículo"
                  style={{
                    backgroundColor: '#444',
                    border: '1px solid #444',
                    marginBottom: '-10px',
                  }}
                  styles={{
                    header: {
                      height: '40px',
                      minHeight: '40px',
                      backgroundColor: '#444',
                      color: '#fff',
                      fontSize: '20px',
                    },
                    body: {
                      paddingTop: '8px',
                      backgroundColor: '#444',
                      color: '#fff',
                    },
                  }}
                >
                  <Row gutter={16} style={{ marginBottom: '-12px' }}>
                    <Col span={6}>
                      <Form.Item
                        label={<span style={{ color: '#fff' }}>Ano de fabricação</span>}
                        name="ano_fabricacao"
                        rules={[
                          { required: true, message: 'Necessário ano de fabricação' },
                        ]}
                      >
                        <Input placeholder="Ano de fabricação" type="number" />
                      </Form.Item>
                    </Col>
                    <Col span={6}>
                      <Form.Item
                        label={<span style={{ color: '#fff' }}>RENAVAN</span>}
                        name="renavam"
                        rules={[
                          { required: true, message: 'Necessário número de  renavan' },
                        ]}
                      >
                        <Input placeholder="Renavan" type="number" />
                      </Form.Item>
                    </Col>
                    <Col span={6}>
                      <Form.Item
                        label={<span style={{ color: '#fff' }}>Estado</span>}
                        name="estado_id"
                        rules={[{ required: true }]}
                      >
                        <Select
                          placeholder="Selecione o estado"
                          style={{ width: '100%' }}
                          showSearch
                          optionFilterProp="children"
                          filterOption={(input, option) =>
                            option?.children
                              ?.toLowerCase()
                              .split('-')[0]
                              .includes(input.toLowerCase())
                          }
                        >
                          {estados.map((estado) => (
                            <Option key={estado.id} value={estado.id}>
                              {`${estado.sigla} - ${estado.nome}`}
                            </Option>
                          ))}
                        </Select>
                      </Form.Item>
                    </Col>
                    <Col span={6}>
                      <Form.Item
                        label={<span style={{ color: '#fff' }}>Chassi</span>}
                        name="chassi"
                        rules={[{ required: true, message: 'Necessário chassi' }]}
                      >
                        <Input placeholder="chassi" type="text" />
                      </Form.Item>
                    </Col>
                  </Row>

                  <Row gutter={16} style={{ marginBottom: '-12px' }}>
                    <Col span={6}>
                      <Form.Item
                        label={<span style={{ color: '#fff' }}>Fabricante</span>}
                        name="fabricante"
                        rules={[{ required: true }]}
                      >
                        <Select
                          placeholder="Selecione fabricante"
                          style={{ width: '100%' }}
                          showSearch
                          optionFilterProp="children"
                          filterOption={(input, option) =>
                            option?.children?.toLowerCase().includes(input.toLowerCase())
                          }
                          onChange={(value) => {
                            const codigo = findCodigoByDescricao(value);
                            setFabricanteCodigo(codigo);

                            form.setFieldValue('modelo', undefined);
                            setModelo([]);
                          }}
                        >
                          {fabricante.map((item) => (
                            <Option key={item.codigo} value={item.descricao}>
                              {`${item.descricao}`}
                            </Option>
                          ))}
                        </Select>
                      </Form.Item>
                    </Col>
                    <Col span={6}>
                      <Form.Item
                        label={<span style={{ color: '#fff' }}>Modelo</span>}
                        name="modelo"
                        rules={[{ required: true }]}
                      >
                        <Select
                          placeholder="Selecione modelo"
                          style={{ width: '100%' }}
                          showSearch
                          optionFilterProp="children"
                          loading={modeloLoading}
                          filterOption={(input, option) =>
                            option?.children?.toLowerCase().includes(input.toLowerCase())
                          }
                        >
                          {modelo.map((item) => (
                            <Option key={item.codigo} value={item.descricao}>
                              {`${item.descricao}`}
                            </Option>
                          ))}
                        </Select>
                      </Form.Item>
                    </Col>
                    <Col span={6}>
                      <Form.Item
                        label={<span style={{ color: '#fff' }}>Tipo de Veículo</span>}
                        name="familia_veiculo_tl"
                        rules={[{ required: true }]}
                      >
                        <Select
                          placeholder="Selecione o tipo veículo"
                          style={{ width: '100%' }}
                          showSearch
                          optionFilterProp="children"
                          filterOption={(input, option) =>
                            option?.children?.toLowerCase().includes(input.toLowerCase())
                          }
                        >
                          {tipoVeiculo.map((item) => (
                            <Option key={item.id} value={item.codigo}>
                              {`${item.codigo} - ${item.descricao}`}
                            </Option>
                          ))}
                        </Select>
                      </Form.Item>
                    </Col>
                    <Col span={6}>
                      <Form.Item
                        label={<span style={{ color: '#fff' }}>Descrição</span>}
                        name="descricao"
                        rules={[{ required: false }]}
                      >
                        <Input placeholder="Descrição adicional" type="text" />
                      </Form.Item>
                    </Col>
                  </Row>

                  <Row gutter={16} style={{ marginBottom: '-12px' }}>
                    {/* não tem na API da TL mudança de combustível */}
                    {/* <Col span={6}>
                      <Form.Item
                        label={<span style={{ color: '#fff' }}>Combustível</span>}
                        name="tipo_combustivel_tl"
                        rules={[{ required: true }]}
                      >
                        <Select
                          placeholder="Selecione combustivel"
                          style={{ width: '100%' }}
                          showSearch
                          optionFilterProp="children"
                          filterOption={(input, option) =>
                            option?.children?.toLowerCase().includes(input.toLowerCase())
                          }
                        >
                          {combustivel.map((item) => (
                            <Option key={item.codigo} value={item.descricao}>
                              {`${item.descricao.toUpperCase()}`}
                            </Option>
                          ))}
                        </Select>
                      </Form.Item>
                    </Col> */}
                    <Col span={6}>
                      <Form.Item
                        label={<span style={{ color: '#fff' }}>Cor</span>}
                        name="cor"
                        rules={[{ required: false }]}
                      >
                        <Input placeholder="Cor" type="text" />
                      </Form.Item>
                    </Col>
                    <Col span={6}>
                      <Form.Item
                        label={
                          <span style={{ color: '#fff' }}>Capacidade do Tanque</span>
                        }
                        name="capacidade_tanque"
                        rules={[{ required: false }]}
                      >
                        <Input placeholder="Capacidade do tanque" type="number" />
                      </Form.Item>
                    </Col>
                    {/* não disponível mudança na API TL */}
                    {/* <Col span={6}>
                      <Form.Item
                        label={
                          <span style={{ color: '#fff' }}>Quilometragem inicial</span>
                        }
                        name="km_inicial"
                        rules={[{ required: false }]}
                      >
                        <Input placeholder="Quilometragem inicial" type="number" />
                      </Form.Item>
                    </Col> */}
                  </Row>
                </Card>

                {/* Informações de Contrato */}
                <Card
                  title="Informações de Contrato"
                  style={{
                    backgroundColor: '#444',
                    border: '1px solid #444',
                    marginTop: '24px',
                    marginBottom: '-10px',
                  }}
                  styles={{
                    header: {
                      height: '40px',
                      minHeight: '40px',
                      backgroundColor: '#444',
                      color: '#fff',
                      fontSize: '20px',
                    },
                    body: {
                      paddingTop: '8px',
                      backgroundColor: '#444',
                      color: '#fff',
                    },
                  }}
                >
                  <Row gutter={16} style={{ marginBottom: '-12px' }}>
                    <Col
                      flex={tipoFrotaWatch !== idTipoContratoAlugado && 'auto'}
                      span={tipoFrotaWatch === idTipoContratoAlugado && 4}
                    >
                      <Form.Item
                        label={<span style={{ color: '#fff' }}>Centro de Custo</span>}
                        name="codigo_cc_tl"
                        rules={[{ required: true }]}
                      >
                        <Select
                          placeholder="Selecione centro de custo"
                          style={{ width: '100%' }}
                          showSearch
                          optionFilterProp="children"
                          filterOption={(input, option) =>
                            option?.children?.toLowerCase().includes(input.toLowerCase())
                          }
                        >
                          {centroCusto.map((item) => (
                            <Option key={item.codigo} value={item.codigo}>
                              {`${item.descricao}`}
                            </Option>
                          ))}
                        </Select>
                      </Form.Item>
                    </Col>

                    <Col span={4}>
                      <Form.Item
                        label={<span style={{ color: '#fff' }}>Tipo de Contrato</span>}
                        name="tipo_frota_tl"
                        rules={[{ required: true }]}
                      >
                        <Select
                          placeholder="Selecione tipo contrato"
                          style={{ width: '100%' }}
                          showSearch
                          optionFilterProp="children"
                          filterOption={(input, option) =>
                            option?.children?.toLowerCase().includes(input.toLowerCase())
                          }
                        >
                          {tiposContrato.map((item) => (
                            <Option key={item.codigo} value={item.codigo}>
                              {`${item.descricao}`}
                            </Option>
                          ))}
                        </Select>
                      </Form.Item>
                    </Col>
                    {tipoFrotaWatch && tipoFrotaWatch === idTipoContratoAlugado && (
                      <Col span={4}>
                        <Form.Item
                          label={<span style={{ color: '#fff' }}>Locadora</span>}
                          name="locadora_id"
                          rules={[{ required: true }]}
                        >
                          <Select
                            placeholder="Selecione locadora"
                            style={{ width: '100%' }}
                            showSearch
                            optionFilterProp="children"
                            filterOption={(input, option) =>
                              option?.children
                                ?.toLowerCase()
                                .includes(input.toLowerCase())
                            }
                          >
                            {locadoras.map((item) => (
                              <Option key={item.id} value={Number(item.id)}>
                                {`${item.nome.toUpperCase()}`}
                              </Option>
                            ))}
                          </Select>
                        </Form.Item>
                      </Col>
                    )}

                    <Col span={4}>
                      <Form.Item
                        label={
                          <span style={{ color: '#fff' }}>{`Valor ${
                            tipoFrotaWatch === idTipoContratoPropria
                              ? 'depreciação'
                              : 'contrato'
                          }`}</span>
                        }
                        name="valor_contrato"
                        rules={[{ required: true }]}
                      >
                        <Input placeholder="Valor depreciação" type="number" />
                      </Form.Item>
                    </Col>
                    <Col span={4}>
                      <Form.Item
                        label={<span style={{ color: '#fff' }}>Inicio contrato</span>}
                        name="inicio_contrato"
                        rules={[{ required: false }]}
                      >
                        <DatePicker
                          placeholder="Selecione a data"
                          style={{ width: '100%' }}
                          format="DD/MM/YYYY"
                        />
                      </Form.Item>
                    </Col>
                    <Col span={4}>
                      <Form.Item
                        label={<span style={{ color: '#fff' }}>Fim contrato</span>}
                        name="fim_contrato"
                        rules={[{ required: false }]}
                      >
                        <DatePicker
                          placeholder="Selecione a data"
                          style={{ width: '100%' }}
                          format="DD/MM/YYYY"
                        />
                      </Form.Item>
                    </Col>
                  </Row>
                </Card>

                {/* Responsáveis e Situação */}
                <Card
                  title="Responsáveis e Situação"
                  style={{
                    backgroundColor: '#444',
                    border: '1px solid #444',
                    marginTop: '24px',
                    marginBottom: '12px',
                  }}
                  styles={{
                    header: {
                      height: '40px',
                      minHeight: '40px',
                      backgroundColor: '#444',
                      color: '#fff',
                      fontSize: '20px',
                    },
                    body: {
                      paddingTop: '8px',
                      backgroundColor: '#444',
                      color: '#fff',
                    },
                  }}
                >
                  <Row gutter={16} style={{ marginBottom: '-12px' }}>
                    <Col flex="auto">
                      <Form.Item
                        label={<span style={{ color: '#fff' }}>Gestor</span>}
                        name="gestor_nome"
                        rules={[{ required: true }]}
                      >
                        <Select
                          placeholder="Selecione gestor"
                          style={{ width: '100%' }}
                          showSearch
                          optionFilterProp="children"
                          filterOption={(input, option) =>
                            option?.children?.toLowerCase().includes(input.toLowerCase())
                          }
                        >
                          {gestores.map((item) => (
                            <Option key={item.codigo} value={`${item.codigo}`}>
                              {`${item.descricao}`}
                            </Option>
                          ))}
                        </Select>
                      </Form.Item>
                    </Col>

                    <Col span={4}>
                      <Form.Item
                        label={<span style={{ color: '#fff' }}>Tipo de Restrição</span>}
                        name="codigo_grupo_restricao_tl"
                        rules={[{ required: true }]}
                      >
                        <Select
                          placeholder="Selecione grupo restricao"
                          style={{ width: '100%' }}
                          showSearch
                          optionFilterProp="children"
                          filterOption={(input, option) =>
                            option?.children?.toLowerCase().includes(input.toLowerCase())
                          }
                        >
                          {grupoRestricao.map((item) => (
                            <Option key={item.codigo} value={item.codigo}>
                              {`${item.descricao}`}
                            </Option>
                          ))}
                        </Select>
                      </Form.Item>
                    </Col>

                    <Col span={4}>
                      <Form.Item
                        label={<span style={{ color: '#fff' }}>Empresa</span>}
                        name="empresa_id"
                        rules={[{ required: true }]}
                      >
                        <Select
                          placeholder="Selecione empresa"
                          style={{ width: '100%' }}
                          showSearch
                          optionFilterProp="children"
                          filterOption={(input, option) =>
                            option?.children?.toLowerCase().includes(input.toLowerCase())
                          }
                        >
                          {empresas.map((item) => (
                            <Option key={item.id} value={item.id}>
                              {`${item.nome_empresa}`}
                            </Option>
                          ))}
                        </Select>
                      </Form.Item>
                    </Col>

                    <Col span={4}>
                      <Form.Item
                        label={<span style={{ color: '#fff' }}>Data entrega</span>}
                        name="data_entrega"
                        rules={[{ required: false }]}
                      >
                        <DatePicker
                          placeholder="Selecione a data"
                          style={{ width: '100%' }}
                          format="DD/MM/YYYY"
                        />
                      </Form.Item>
                    </Col>
                    <Col span={4}>
                      <Form.Item
                        label={<span style={{ color: '#fff' }}>Data devolução</span>}
                        name="data_devolucao"
                        rules={[{ required: false }]}
                      >
                        <DatePicker
                          placeholder="Selecione a data"
                          style={{ width: '100%' }}
                          format="DD/MM/YYYY"
                        />
                      </Form.Item>
                    </Col>
                  </Row>
                </Card>

                {/* Rastreador e Tags */}
                <Card
                  title="Rastreador e Tags"
                  style={{
                    backgroundColor: '#444',
                    border: '1px solid #444',
                    marginTop: '24px',
                    marginBottom: '12px',
                  }}
                  styles={{
                    header: {
                      height: '40px',
                      minHeight: '40px',
                      backgroundColor: '#444',
                      color: '#fff',
                      fontSize: '20px',
                    },
                    body: {
                      paddingTop: '8px',
                      backgroundColor: '#444',
                      color: '#fff',
                    },
                  }}
                >
                  <Row gutter={16} style={{ marginBottom: '-12px' }}>
                    <Col span={6}>
                      <Form.Item
                        label={
                          <span style={{ color: '#fff' }}>Empresa de Rastreador</span>
                        }
                        name="rastreador_empresa_id"
                        rules={[{ required: true }]}
                      >
                        <Select
                          placeholder="Selecione rastreador"
                          style={{ width: '100%' }}
                          showSearch
                          optionFilterProp="children"
                          filterOption={(input, option) =>
                            option?.children?.toLowerCase().includes(input.toLowerCase())
                          }
                        >
                          {rastreadores.map((item) => (
                            <Option key={item.id} value={item.id}>
                              {`${item.nome_empresa}`}
                            </Option>
                          ))}
                        </Select>
                      </Form.Item>
                    </Col>

                    <Col span={6}>
                      <Form.Item
                        label={<span style={{ color: '#fff' }}>Empresa de Tags</span>}
                        name="tag_id"
                        rules={[{ required: true }]}
                      >
                        <Select
                          placeholder="Selecione tags"
                          style={{ width: '100%' }}
                          showSearch
                          optionFilterProp="children"
                          filterOption={(input, option) =>
                            option?.children?.toLowerCase().includes(input.toLowerCase())
                          }
                        >
                          {tags.map((item) => (
                            <Option key={item.id} value={item.id}>
                              {`${item.nome.toUpperCase()}`}
                            </Option>
                          ))}
                        </Select>
                      </Form.Item>
                    </Col>
                  </Row>
                </Card>
              </Form>
            )}
          </div>
        </Modal>
      )}
    </div>
  );
}
